import { useEffect, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { verifyAdminSession } from '@/api/adminApi'
import { isAdmin, markAdminSessionActive, setAdmin } from '@/utils/adminAuth'
import { setTenantSlug } from '@/config/tenant'
import { AdminLoginPage } from './AdminLoginPage'

export function AdminLoginOrRedirect() {
  const [searchParams] = useSearchParams()
  const [checking, setChecking] = useState(!isAdmin())
  const [valid, setValid] = useState(isAdmin())

  useEffect(() => {
    const tenantFromUrl = searchParams.get('tenant')?.trim().toLowerCase()
    if (tenantFromUrl) setTenantSlug(tenantFromUrl)

    if (isAdmin()) {
      setValid(true)
      setChecking(false)
      return
    }

    let cancelled = false
    verifyAdminSession()
      .then((data) => {
        if (cancelled) return
        const slug = data.tenantSlug || tenantFromUrl || ''
        if (slug) setTenantSlug(slug)
        setAdmin(null, data.email, { tenantSlug: slug })
        markAdminSessionActive()
        setValid(true)
      })
      .catch(() => {
        if (!cancelled) setValid(false)
      })
      .finally(() => {
        if (!cancelled) setChecking(false)
      })

    return () => {
      cancelled = true
    }
  }, [searchParams])

  if (checking) return null

  if (valid) {
    const tenant = searchParams.get('tenant')
    const suffix = tenant ? `?tenant=${encodeURIComponent(tenant)}` : ''
    return <Navigate to={`/admin/dashboard${suffix}`} replace />
  }

  return <AdminLoginPage />
}
